import atoms from './atoms';
import layouts from './layouts';
import molecules from './molecules';
import organisms from './organisms';
import templates from './templates';

export default {
	...atoms,
	...layouts,
	...molecules,
	...organisms,
	...templates
};
